var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-bar"},[_c('div',{staticClass:"loading-bar-message"},[_c('p',[_vm._v(_vm._s(_vm.message))])]),_c('ProgressBar',{attrs:{"width":"65","completed":_vm.completed}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }